/**
 * <tabbed-trust> - simple tab switcher: click a pill, show the matching panel.
 */
class TabbedTrust extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tab));
    });
  }

  activate(id) {
    this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.tab === id));
    this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.panel === id));
  }
}

if (!customElements.get('tabbed-trust')) {
  customElements.define('tabbed-trust', TabbedTrust);
}
